module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.d0eace89.jpg";